import { render, staticRenderFns } from "./YKPayments.vue?vue&type=template&id=522df28c&"
import script from "./YKPayments.vue?vue&type=script&lang=js&"
export * from "./YKPayments.vue?vue&type=script&lang=js&"
import style0 from "./YKPayments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports